module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": "风险测评",
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "test-propress"
  }, [_c('div', {
    staticClass: "index-tip"
  }, [_c('span', {
    style: (_vm.prevStyle),
    on: {
      "click": function($event) {
        _vm.$_evaluation_prev(_vm.index)
      }
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.index < 10 ? '0' + _vm.index : _vm.index) + "/" + _vm._s(_vm.total))]), _vm._v(" "), _c('span', {
    style: (_vm.nextStyle),
    on: {
      "click": function($event) {
        _vm.$_evaluation_next(_vm.index)
      }
    }
  }, [_vm._v("下一题")])]), _vm._v(" "), _c('div', {
    staticClass: "propress-box"
  }, [_c('div', {
    staticClass: "propress-style",
    style: ({
      width: _vm.progressPercent
    })
  })])]), _vm._v(" "), _vm._l((_vm.question), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.index === (key + 1)),
        expression: "index === (key + 1)"
      }]
    }, [_c('div', {
      staticClass: "evaluation-title"
    }, [_vm._v("\n          " + _vm._s((_vm.index + "、" + (item.title))) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "options-list"
    }, [_c('group', [_c('radio', {
      attrs: {
        "options": item.options
      },
      nativeOn: {
        "click": function($event) {
          _vm.change(_vm.index)
        }
      },
      scopedSlots: _vm._u([{
        key: "each-item",
        fn: function(scope) {
          return [_c('div', {
            class: {
              'selected-style': scope.selected, 'item-box': true
            }
          }, [_c('div', {
            staticClass: "item-box-con"
          }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAnswer")(scope.label, scope.index)) + "\n                  ")])])]
        }
      }]),
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1)], 1)])
  }), _vm._v(" "), (_vm.index === _vm.total) ? _c('div', {
    staticClass: "tip-text"
  }, [_c('div', {
    staticClass: "empty-split"
  }), _vm._v(" "), _c('h4', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("本人已经了解并愿意遵守国家有关证券市场、基金市场管理的法律、法规、规章及相关业务规则，本人在此郑重承诺以上填写的内容真实、准确、完整。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。")])]) : _vm._e(), _vm._v(" "), _c('submit-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === _vm.total),
      expression: "index === total"
    }],
    attrs: {
      "disabled": !_vm.isSubmit
    },
    on: {
      "click": function($event) {
        _vm.$_evaluation_submitCal(_vm.index)
      }
    }
  }, [_vm._v("提 交")])], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d64e3ef2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Evaluation/Question.vue
// module id = 1087
// module chunks = 1